<!--
- 公司列表组件
- anthor: wang.y
- greatTime: 2019-08-12
-->
<template>
    <li>
        <div class="logo_img" @click="goEntityDetail(dataLi.uid)">
            <img :src="dataLi.logo_path | logo_show" />
        </div>
        <div class="entity_info">
            <p class="p1 clear">
              <span
                  class="span_name"
                  v-html="filter.keyWordHighLight(dataLi.short_name, keyword)"
                  @click="goEntityDetail(dataLi.uid)"
              ></span>
              <span class="span_tag" v-if="dataLi.round_id">{{dataLi.round_id | deal('round')}}</span>
            </p>
            <p class="p2" v-if="dataLi.description"  v-html="filter.keyWordHighLight(dataLi.description, keyword)"></p>
            <p class="p2" v-else>暂无描述</p>
        </div>
        <div class="entity_chk">
            <EntityAttention :entityItem="dataLi" :entityType="0">
                <span class="spa1" slot="slot1"><i class="iconfont">&#xe64a;</i>关注</span>
                <span class="spa2" slot="slot2"><i class="iconfont">&#xe64b;</i>已关注</span>
            </EntityAttention>
        </div>
    </li>
</template>

<script>
import EntityAttention from '../../DataList/components/EntityAttention.vue'
import filter from 'js/filter'
export default {
  inject: ['login'],
  props: ['dataLi', 'keyword'],
  components: {
    EntityAttention
  },
  data() {
    return {
      filter: filter
    }
  },
  methods: {
    /**
    * 前往实体详情
    */
    goEntityDetail(uid) {
      if (this.$store.state.user_key) {
        // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else {
        this.login()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/searchEntity.stylus'
</style>
